export enum RequestStatus {
  INITIAL = 'initial',
  PENDING = 'pending',
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected',
}
